import React from 'react'

export default props => (
    <div className='card-footer' style={{ ...props.style, padding: 8 }}>
        {props.children}
    </div>
)
